import React from 'react';

const NationStateBitcoinHoldings = () => {
  const holdingsData = [
    { rank: 1, country: 'United States', btc: 213297, value: '$14.82 billion' },
    { rank: 2, country: 'China', btc: 190000, value: '$13.20 billion' },
    { rank: 3, country: 'United Kingdom', btc: 61000, value: '$4.24 billion' },
    { rank: 4, country: 'El Presidency Salvador', btc: 5800, value: '$0.40 billion' },
    { rank: 5, country: 'Ukraine', btc: 1344, value: '$0.09 billion' },
  ];

  return (
    <div className="card bg-dark border-warning">
      <div className="card-body">
        <h2 className="text-warning text-center mb-4">Nation State Bitcoin Holdings</h2>
        <div className="table-responsive">
          <table className="table table-dark table-hover">
            <thead>
              <tr>
                <th scope="col">Rank</th>
                <th scope="col">Country</th>
                <th scope="col">Bitcoin Holdings (BTC)</th>
                <th scope="col">Value (USD)</th>
              </tr>
            </thead>
            <tbody>
              {holdingsData.map((country) => (
                <tr key={country.rank}>
                  <td>{country.rank}</td>
                  <td>{country.country}</td>
                  <td>{country.btc.toLocaleString()}</td>
                  <td>{country.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default NationStateBitcoinHoldings;